import * as React from 'react';
import s from './singleArticle.scss';
import {convertToHTML} from '../../utils/article-utils/formatter';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {getTagByPath} from '../../utils';
import * as seo from '../../utils/seo';
import {Experiment} from '../../reducers/experiments';

type SingleArticleProps = {
  t?: (...args: any[]) => any,
  loadArticles: (...args: any[]) => any,
  experiments: Experiment[],
  article: {
    content: string;
    title: string;
    basePath: string;
    id: string;
    date: string;
  }
};
class SingleArticle extends React.Component<SingleArticleProps, {}> {
  render() {
    const {t, article, loadArticles} = this.props;
    const content = convertToHTML(article.content);
    return (
      <div data-hooks="single-article-component" className={s.layout}>
        {seo.generateHelmet({
          title: article.title,
          description: content,
          url: `${article.basePath}/article/${article.id}`
        })}
        <label className={s.date}>{article.date}</label>
        <h1 className={s.title}>{article.title}</h1>
        <span className={s.content}>{content}</span>
        <div className={s.footer}>
          <Link
            to="/"
            className={s.button}
            onClick={() => loadArticles(getTagByPath('/', this.props.experiments))}
          >
            {t('single.article.see.all.updates.button')}
          </Link>
        </div>
      </div>
    );
  }
}
export default withTranslation()(SingleArticle);
